import { LifestyleCategoriesPageTemplate } from "./template";
import { useLifestyleCategoriesPage } from "./logic";

export const LifestyleCategoriesPage = () : JSX.Element => {
    const props = useLifestyleCategoriesPage();

    return (
        <LifestyleCategoriesPageTemplate {...props}/>
    )
} 